<div class="message message-warning">
  <% var noMatchKey = returning_patient ? 'returning' : 'new' %>
  <p><%= I18n.visit.callouts.no_matching_visit_type[noMatchKey].replace('%{provider}', provider.name).replace('%{visit_type}', last_valid_visit_type.name) %></p>
</div>
